// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__543pR","modal":"modal_modal__8H65C","form":"modal_form__xXRqr","label":"modal_label__dmKd0"};